import { ReactNode } from "react";
import { KeyValueList } from "../key-value-list";
import { CollateralAprSimulator } from "./collateral-apr-simulator";
import { ProtectedAprSimulator } from "./protected-apr-simulator";
import { DebtAprSimulator } from "./debt-apr-simulator";
import {
  getCollateralCurrentMetrics,
  getCollateralNewMetrics,
} from "./collateral-apr-simulator/utils";
import {
  getDebtCurrentMetrics,
  getDebtNewMetrics,
} from "./debt-apr-simulator/utils";

export const AprSimulator = {
  Root,
  CollateralAprSimulator,
  ProtectedAprSimulator,
  DebtAprSimulator,

  getCollateralCurrentMetrics,
  getCollateralNewMetrics,
  getDebtCurrentMetrics,
  getDebtNewMetrics,
};

export type { CollateralAprSimulatorProps } from "./collateral-apr-simulator";
export type {
  CollateralCurrentState,
  CollateralNewState,
} from "./collateral-apr-simulator/types";
export type { ProtectedAprSimulatorProps } from "./protected-apr-simulator";
export type { ProtectedState } from "./protected-apr-simulator/types";
export type { DebtAprSimulatorProps } from "./debt-apr-simulator";
export type {
  DebtCurrentState,
  DebtNewState,
} from "./debt-apr-simulator/types";

interface RootProps {
  className?: string;
  children?: ReactNode;
}

export function Root({ className, children }: RootProps): JSX.Element {
  return (
    <KeyValueList className={className} divider>
      {children}
    </KeyValueList>
  );
}
